export const ACTION_DASHBOARD_SEARCH = 'ACTION_DASHBOARD_SEARCH';

export const DashboardActions = {
  actionDashboardSetSearchTerm: (term: string) => ({
    type: ACTION_DASHBOARD_SEARCH,
    term,
  }),
};
